// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"16":"votacion","109":"altares","754":"jornada-artistas","907":"cdi","918":"literature"}[chunkId] || chunkId) + "." + {"16":"7c517d4e","109":"1a544da5","483":"6683b617","754":"a2847bba","907":"cb999e54","918":"a2847bba"}[chunkId] + ".css";
};